import { Button } from "@/app/(components)/Basic/Button";
import useMe from "@/shared/hooks/useMe";
import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export interface Props {
  icon: ReactNode;
  color: string;
  label: string | number;
  onClick: () => void;
  href?: string;
  target?: string;
  labelClassName?: string;
}

const FooterAction = ({
  icon,
  color,
  label,
  onClick,
  href,
  target,
  labelClassName,
}: Props) => {
  const { me } = useMe();

  return (
    <li key={label} className="last:ml-auto">
      <Button
        native
        onClick={() => onClick()}
        href={href}
        startIcon={icon}
        className={twMerge(
          "flex text-body-4 items-center gap-1",
          color === "red" && "text-red",
          color === "primary" && "text-primary",
        )}
        disabled={!me}
        target={target}
      >
        <label
          className={twMerge(
            "text-sm/[17px] md:block cursor-pointer endemic:text-primary",
            !me && "cursor-auto endemic:opacity-60",
            labelClassName,
          )}
        >
          {label}
        </label>
      </Button>
    </li>
  );
};

export default FooterAction;
